'use client'

import { memo } from 'react'

import ChartCardLoading from '@/components/charts/components/ChartCardLoading'

const VaultV2ChartSharePriceLoading = () => {
  return (
    <ChartCardLoading
      className="gap-lg"
      chartClassName="h-[224px]"
      titleClassName="w-[188px]"
      valueClassName="h-[44px] w-[272px]"
      controls={['h-8 w-[103px]']}
    />
  )
}

export default memo(VaultV2ChartSharePriceLoading)
